import { REQUEST } from '@/constants';

export const SUBSCRIPTION_TYPES_FETCH = 'SUBSCRIPTION_TYPES_FETCH';
export const SUBSCRIPTION_TYPES_SET = 'SUBSCRIPTION_TYPES_SET';
export const SUBSCRIPTION_TYPE_CREATE = 'SUBSCRIPTION_TYPE_CREATE';
export const SUBSCRIPTION_TYPE_UPDATE = 'SUBSCRIPTION_TYPE_UPDATE';
export const SUBSCRIPTION_TYPE_DELETE = 'SUBSCRIPTION_TYPE_DELETE';
export const CLIENT_SUBSCRIPTION_FETCH = 'CLIENT_SUBSCRIPTION_FETCH';
export const CLIENT_SUBSCRIPTION_ASSIGN = 'CLIENT_SUBSCRIPTION_ASSIGN';
export const CLIENT_SUBSCRIPTION_REMOVE = 'CLIENT_SUBSCRIPTION_REMOVE';
export const CLIENT_BOOKING_AVAILABILITY = 'CLIENT_BOOKING_AVAILABILITY';

export default {
    state: {
        types: [],
    },
    mutations: {
        [SUBSCRIPTION_TYPES_SET](state, types) {
            state.types = types;
        },
    },
    actions: {
        async [SUBSCRIPTION_TYPES_FETCH]({ commit, dispatch }) {
            const res = await dispatch(REQUEST, { url: 'subscription-types' });
            if (res && res.status === 200) {
                commit(SUBSCRIPTION_TYPES_SET, res.data.data);
            }
        },
        async [SUBSCRIPTION_TYPE_CREATE]({ dispatch }, data) {
            return await dispatch(REQUEST, { method: 'post', url: 'subscription-types', data });
        },
        async [SUBSCRIPTION_TYPE_UPDATE]({ dispatch }, { id, data }) {
            return await dispatch(REQUEST, {
                method: 'put',
                url: `subscription-types/${id}`,
                data,
            });
        },
        async [SUBSCRIPTION_TYPE_DELETE]({ dispatch }, { id }) {
            return await dispatch(REQUEST, {
                method: 'delete',
                url: `subscription-types/${id}`,
            });
        },
        async [CLIENT_SUBSCRIPTION_FETCH]({ dispatch }, { clientId }) {
            return await dispatch(REQUEST, { url: `clients/${clientId}/subscription` });
        },
        async [CLIENT_SUBSCRIPTION_ASSIGN]({ dispatch }, { clientId, subscriptionTypeId }) {
            return await dispatch(REQUEST, {
                method: 'post',
                url: `clients/${clientId}/subscription`,
                data: { subscription_type_id: subscriptionTypeId },
            });
        },
        async [CLIENT_SUBSCRIPTION_REMOVE]({ dispatch }, { clientId }) {
            return await dispatch(REQUEST, {
                method: 'delete',
                url: `clients/${clientId}/subscription`,
            });
        },
        async [CLIENT_BOOKING_AVAILABILITY]({ dispatch }, { clientId, weekStart }) {
            return await dispatch(REQUEST, {
                url: `clients/${clientId}/booking-availability`,
                params: { week_start: weekStart },
            });
        },
    },
};
